/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const userState = (initiate = true) => ({
  details: { phoneNumber: null },
  shopifyDetails: {},
  authToken: initiate ? window.localStorage.getItem("authToken") ?? null : null,
  subscribe: true,
  error: null
});

const userSlice = createSlice({
  name: "user",
  initialState: userState(),
  reducers: {
    setToken(state, { payload }) {
      window.localStorage.setItem("authToken", payload);
      state.authToken = payload;
    },
    checkToken(state, { payload }) {
      try {
        const token = window.localStorage.getItem("authToken", payload);
        state.authToken = token;
      } catch (error) {
        if (!state.authToken) {
          state.authToken = null;
        }
      }
    },
    setSubscibe(state, { payload }) {
      state.subscribe = payload.subscribe;
    },
    setUserDetails(state, { payload }) {
      Object.keys(payload).forEach((key) => {
        if (payload[key]) {
          state.details = { ...state.details, [key]: payload[key] };
        }
      });
    },
    setUserShopifyDetails(state, { payload }) {
      Object.keys(payload).forEach((key) => {
        if (payload[key]) {
          state.shopifyDetails = {
            ...state.shopifyDetails,
            [key]: payload[key]
          };
        }
      });
    },
    resetPhoneNumber(state) {
      state.details = {
        phoneNumber: null
      };
    },
    resetUserStore(state) {
      state.details = {
        phoneNumber: null
      };
      state.authToken = null;
      window.localStorage.clear();
    }
  }
});

export const {
  setToken,
  checkToken,
  setUserDetails,
  setSubscibe,
  setUserShopifyDetails,
  resetPhoneNumber,
  resetUserStore
} = userSlice.actions;
export default userSlice.reducer;
